module.exports = __webpack_public_path__ + "6d7f2254f10f76e2b55b98c7ae54bcdb.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/assets/jacktop_black_jack.png
// module id = 1683
// module chunks = 2